import { render, staticRenderFns } from "./EditMaterialTagPopup.vue?vue&type=template&id=3c87282e"
import script from "./EditMaterialTagPopup.vue?vue&type=script&lang=js"
export * from "./EditMaterialTagPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports